// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { getBaseEmployersQuery, getBasePaySchedulesQuery } from './payroll/utils'
import { type GeneratePayScheduleFormProps } from '../../types/payroll'

type ResponseType = {
  redirect_to: string
}

export function useCreatePaySchedule () {
  const queryClient = useQueryClient()

  return useMutation<
   ResponseType,
    GrapeAPIErrorType,
    GeneratePayScheduleFormProps
  >({
    mutationFn: async (data: GeneratePayScheduleFormProps) => {
      const request = new FetchRequest(
        'post',
        '/api/web/payroll/pay_schedules',
        {
          headers: {
            Accept: 'application/json',
          },
          body: data,
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getBasePaySchedulesQuery() })
      queryClient.invalidateQueries({ queryKey: [...getBaseEmployersQuery(), 'unassignedEmployees'] })
    },
  })
}
